// Canonical access rules for the Payment Processors module.
//
// Sidebar visibility and the route guards both read this, so a nav link can
// never appear for someone the routes would bounce, or vice versa.
//
// Permission values carry a historical triple-S typo
// (PAYMENT_PROCESSSORS_VIEW / _EDIT / _DELETE), so match on the suffix rather
// than the full literal.

const norm = (value: unknown) =>
  (value ? String(value) : "").toLowerCase().replace(/[\s_-]/g, "");

// Legacy fallback: full "Dashboard Organizer" (role 22, ~672 active users) was
// given the read-only view without ever being granted an explicit permission.
//
// This is an EXACT match on purpose. It used to be a substring match, which
// also caught "Dashboard Organizer - Reporting Only" (role 24) — handing the
// page to the very role created to withhold it. Do not loosen it back.
//
// Grant role 22 PAYMENT_PROCESSSORS_VIEW in the Role editor and this branch
// can be deleted outright.
const isLegacyDashboardOrganizer = (user: any) =>
  norm(user?.role?.display_name) === "dashboardorganizer" ||
  norm(user?.role?.name) === "dashboardorganizer";

export const processorAccessFor = (user: any) => {
  const granted: any[] = user?.role?.permissions?.payment_processors ?? [];
  const has = (suffix: string) =>
    granted.some(
      (entry) => typeof entry?.value === "string" && entry.value.includes(suffix)
    );
  const isAdmin = user?.role_id === 1;

  return {
    // Legacy organizers get read access only — never edit or delete.
    view: isAdmin || has("_VIEW") || isLegacyDashboardOrganizer(user),
    edit: isAdmin || has("_EDIT"),
    remove: isAdmin || has("_DELETE"),
  };
};

export type ProcessorCapability = keyof ReturnType<typeof processorAccessFor>;
